(function ($) {
    var $fn = $(".comp_my_hierarchy");

    if ($fn.length) {

    }
})(jQuery);